export const ironBuildVersionIsV3 = process.env.IRON_BUILD_VERSION !== 'v4';
export const ironBuildVersionIsV4 = process.env.IRON_BUILD_VERSION === 'v4';
